export default {
  languageName: 'Français',
  nav: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    learn: 'Apprendre',
    tos: 'Conditions de service',
    search: 'Chercher...'
  },
  account: {
    login: 'Connexion',
    logout: 'Déconnexion',
    hello: 'Bonjour'
  },
  login: {
    connect: 'Je me connecte',
    required: 'Vous devez vous connecter pour voir cette page',
    unauthorized: 'Votre session a expiré',
    email: 'E-mail',
    password: 'Mot de passe',
    incorrect: 'Information dʼauthentification invalide'
  },
  profile: {
    connect: 'Continer',
    select: 'Choisissez un profil…',
    selectTitle: 'Choisissez un profil',
    yourProfileLabel: 'Votre profil',
    emailLabel: 'Courriel',
    passwordLabel: 'Mot de passe',
    confirmPasswordLabel: 'Confirmer le mot de passe'
  },
  dashboard: {
    title: 'Tableau de bord'
  },
  home: {
    welcome: 'Bienvenue'
  },
  tos: {
    title: 'Conditions de service',
    text_markdown:
      'French terms go here. This supports _[markdown!](https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet)_'
  },
  learn: {
    title: 'Apprendre',
    subtitle: "Qu'aimeriez-vous apprendre?",
    references: 'Références'
  },
  moduleCard: {
    module: 'CHAPITRE',
    start: 'ALLONS-Y'
  },
  moduleDetail: {
    learn: 'APPRENDRE',
    chapter: 'CHAPITRE',
    lessons: 'Leçons'
  },
  lessonCard: {
    lesson: 'LEÇON',
    start: 'ALLONS-Y'
  },
  moduleIntroPage: {
    chapter: 'CHAPITRE',
    introduction: 'INTRODUCTION'
  },
  lessonPage: {
    backTo: 'Retour à',
    chapter: 'Chapitre',
    lesson: 'LEÇON'
  },
  diary: {
    diary: 'Laitier',
    pin: 'Votre code PIN',
    email: 'E-mail de secours'
  },
  diarySetup: {
    title: 'Installation laitière',
    backToDiary: 'Retour à mon journal',
    complete: 'Votre code PIN est prêt!',
    pinDescription:
      'Veuillez sélectionner un code PIN à 4 chiffres pour protéger votre vie privée.',
    emailDescription:
      'Si vous oubliez votre code PIN, nous vous enverrons un message de réinitialisation à cet e-mail.',
    start: 'COMMENCER!'
  },
  diaryLock: {
    pinEntry: 'Please enter your Privacy PIN to access your Diary',
    incorrect: 'The entered PIN is incorrect',
    resetPin: 'Dont remember your PIN? Reset it by email.'
  }
};
